import React from "react";
import { Button, Table, Card } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const ClientsList = () => {
  const navigate = useNavigate();

  const handleAddNew = () => {
    navigate("/ats/clients/new");
  };

  const columns = [
    { title: "Client Name", dataIndex: "name", key: "name" },
    { title: "Industry", dataIndex: "industry", key: "industry" },
    { title: "Contact", dataIndex: "contact", key: "contact" },
    { title: "Email", dataIndex: "email", key: "email" },
  ];

  const data = [
    { key: 1, name: "TechCorp", industry: "Software", contact: "David Green", email: "david@techcorp.com" },
    { key: 2, name: "NextGen Ltd", industry: "Consulting", contact: "Anna White", email: "anna@nextgen.com" },
  ];

  return (
    <Card
      title="Clients"
      extra={
        <Button type="primary" icon={<PlusOutlined />} onClick={handleAddNew}>
          Add New
        </Button>
      }
      styles={{ header: { flexWrap: "wrap", height: "auto", rowGap: 8 } }}
    >
      <Table
        columns={columns}
        dataSource={data}
        scroll={{ x: "max-content" }}
        pagination={{ pageSize: 10 }}
      />
    </Card>
  );
};

export default ClientsList;
